<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">材料分类</div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :not-operate="true" :menu-data="classifyList" @on-choose="onChooseMenu"
          :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-46b8b0"></span>
            {{ currentClassify.name }}
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable
              @keyup.enter.native="onSearch"></el-input>
          </div>
          <button class="btn-30-bg-46b8b0" @click="onSearch">搜索</button>
        </div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading"
            :column-data="columnData"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
        </Pagination>
      </div>
      <move-vertical :max="560" :min="150" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 220px">
        <div class="flex align-center bg-ff mb-10 plr-10" style="padding-top:5px;">
          <div class="flex align-center mr-20 cursor pb-5 relative" :class="{ 'tabActive': index === smallTabIndex }"
            v-for="(item, index) in smallTab" v-if="index === 1" :key="index" @click="switchSmallTab(index)">
            <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === smallTabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}</div>
          </div>
        </div>
        <!-- <div class="hr mb-10"></div> -->
        <div class="overflow-y flex-1">
          <div class="text-left h-100" v-if="smallTabIndex === 0">
            <div class="flex flex-wrap w-100">
              <div class="info-item">
                <div>材料名称：{{ currentRow.name }}</div>
              </div>
              <div class="info-item">
                <div>材料编码：{{ currentRow.code }}</div>
              </div>
              <div class="info-item">
                <div>品类：{{ currentRow.category }}</div>
              </div>
              <div class="info-item">
                <div>品牌：{{ currentRow.brand }}</div>
              </div>
              <div class="info-item">
                <div>色号：{{ currentRow.colorNumber }}</div>
              </div>
              <div class="info-item">
                <div>规格：{{ currentRow.standard }}</div>
              </div>
              <div class="info-item">
                <div>型号：{{ currentRow.model }}</div>
              </div>
              <div class="info-item">
                <div>销售单位：{{ currentRow.salesUnit }}</div>
              </div>
              <div class="info-item">
                <div>采购单位：{{ currentRow.purchasingUnit }}</div>
              </div>
              <div class="info-item">
                <div>供应商：{{ currentRow.businessName }}</div>
              </div>
            </div>
          </div>
          <div class="text-left font-12-30313a h-100" v-if="smallTabIndex === 1">
            <div>{{ currentRow.description || '暂无说明！' }}</div>
          </div>
          <div class="text-left flex h-100" v-if="smallTabIndex === 2">
            <div v-for="(item, index) in currentRow.materialPhotoList" :key="index" class="mr-10" style="width: 90px">
              <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList"
                fit="cover"></el-image>
              <div class="font-12-30313a text-center w-100 text-overflow">{{ item.name }}</div>
            </div>
          </div>
          <div class="text-left flex h-100" v-if="smallTabIndex === 3">
            <el-card :body-style="{ padding: '10px', display: 'flex', position: 'relative' }" v-if="currentRow.qrPath">
              <div class="h-100 flex" @click="toBigImg">
                <img :src="currentRow.qrPath" style="width: 70px; height: 70px; margin-right: 10px">
                <div class="flex-column justify-center">
                  <span class="font-12-30313a">二维码编号{{ currentRow.qrCode || '' }}</span>
                  <div class="font-13-46b8b0">查看大图</div>
                </div>
              </div>
              <i class="el-icon-zoom-in"></i>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" title="二维码详情" width="640px"
      :visible.sync="isErcodeShow">
      <div class="flex" style="padding: 30px 40px 40px;">
        <img :src="currentRow.qrPath" style="width: 240px;height: 240px; margin-right: 40px;" alt="">
        <div class="flex-1">
          <div style="padding: 28px 0 36px; border-bottom: 1px dashed #e2e2e2; margin-bottom: 36px"
            class="font-22-30313a text-left">
            二维码编号{{ currentRow.qrCode || '' }}
          </div>
          <div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">材料名称：</div>
              <div class="font-12-30313a">{{ currentRow.name }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">材料编码：</div>
              <div class="font-12-30313a">{{ currentRow.code }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;类：</div>
              <div class="font-12-30313a">{{ currentRow.category }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">品&nbsp;&nbsp;牌&nbsp;&nbsp;名：</div>
              <div class="font-12-30313a">{{ currentRow.brand }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">供&nbsp;&nbsp;应&nbsp;&nbsp;商：</div>
              <div class="font-12-30313a">{{ currentRow.brand }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'materialSearch',
  components: { Pagination, MoveHorizon, CateMenu, ErpTable, MoveVertical },
  data () {
    return {
      keywords: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      classifyList: [],
      columnData: [
        {
          //   field: 'specialItem',
          //   title: '特项',
          //   width: '55'
          // }, {
          field: 'name',
          title: '材料名称',
          width: '100'
          // }, {
          //   field: 'code',
          //   title: '材料编码',
          //   width: '100'
        }, {
          field: 'category',
          title: '品类',
          width: '100'
        }, {
          field: 'brand',
          title: '品牌名',
          minWidth: '120'
        }, {
          field: 'colorNumber',
          title: '色号',
          width: '100'
        }, {
          field: 'standard',
          title: '规格',
          width: '80'
        }, {
          field: 'model',
          title: '型号',
          width: '80'
        }, {
          //   field: 'purchasingUnit',
          //   title: '采购单位',
          //   width: '100'
          // }, {
          field: 'salesUnit',
          title: '单位',
          width: '100'
        },
        // {
        //   field: 'businessName',
        //   title: '供应商',
        //   width: '150'
        // }, {
        //   field: 'costPrice',
        //   title: '成本价',
        //   width: '100'
        // }, {
        //   field: 'weightedCostPrice',
        //   title: '加权成本价',
        //   width: '100'
        // }
        {
          field: 'customerPrice',
          title: '客户价',
          width: '100'
        }
        // , {
        //   field: 'projectManagerPrice',
        //   title: '项目经理价',
        //   width: '100'
        // }, {
        // { field: 'customPrice1',
        //   title: '自定义价格1',
        //   width: '100'
        // }, {
        //   field: 'customPrice2',
        //   title: '自定义价格2',
        //   width: '100'
        // }, {
        //   field: 'customPrice3',
        //   title: '自定义价格3',
        //   width: '100'
        // }, {
        //   field: 'customPrice4',
        //   title: '自定义价格4',
        //   width: '100'
        // }, {
        //   field: 'customPrice5',
        //   title: '自定义价格5',
        //   width: '100'
        // }, {
        //   field: 'customPrice6',
        //   title: '自定义价格6',
        //   width: '100'
        // }, {
        //   field: 'customPrice7',
        //   title: '自定义价格7',
        //   width: '100'
        // }, {
        //   field: 'customPrice8',
        //   title: '自定义价格8',
        //   width: '100'
        // }, {
        //   field: 'customPrice9',
        //   title: '自定义价格9',
        //   width: '100'
        // }, {
        //   field: 'customPrice10',
        //   title: '自定义价格10',
        //   width: '100'
        // }
        // , {
        //   field: 'modifierName',
        //   title: '最后修改人',
        //   width: '100'
        // }, {
        //   field: 'modifyTime',
        //   title: '最后修改时间',
        //   width: '100',
        //   formatter: ['toDateString', 'yyyy-MM-dd']
        // }
      ],
      chooseMenuId: 0,
      currentClassify: {},
      loading: false,
      tableData: [],
      srcList: [],
      smallTab: ['材料信息', '材料说明', '材料图片', '二维码'],
      smallTabIndex: 1,
      isErcodeShow: false,
      currentRow: {},
      isClassifyShow: true
    }
  },
  created () {
    this.getPriceData()
    this.getClassify()
  },
  mounted () { },
  methods: {
    onSearch () {
      this.page = 1
      this.isClassifyShow = false
      this.getClassify()
      this.getMaterial()
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getMaterial()
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.getMaterial(true)
      }
    },
    getPriceData () {
      this.axios.post('materialPrice/list', { companyId: this.$store.state.companyId, status: 1 }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              this.columnData.push(
                {
                  field: list[i].customerPriceField,
                  title: list[i].name,
                  width: '100'
                }
              )
            }
          }
        }
      })
    },
    getMaterial (isRefresh) {
      this.tableData = []
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        companyId: this.$store.state.companyId,
        status: 1
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenuId
      }
      this.axios.post(`material/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (this.tableData.length > 0) {
            this.currentRow = this.tableData[0]
            this.srcList = []
            for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
              this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
            }
          }
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`materialClassify/findAllClassify`, { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        // if (classify.children && classify.children.length) {
        //   this.getDefaultId(classify.children)
        // } else {
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getMaterial(true)
        // }
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.srcList = []
      for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
        this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
      }
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    toBigImg () {
      this.isErcodeShow = true
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getMaterial()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.content-top {
  height: 30px;

  .tab-item {
    font-size: 16px;
    color: #272727;
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;

    span {
      height: 16px;
    }

    &.active {
      color: #46b8b0;
    }
  }
}

.el-icon-zoom-in {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  color: #30313a;
}

.font-13-46b8b0 {
  font-size: 13px;
  color: #46b8b0;
}

.el-card {
  height: 90px;
  border: 1px solid #e2e2e2;
  cursor: pointer;
}

.info-item {
  width: 198px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #30313a;
  margin-right: 30px;
  line-height: 20px;
  height: 20px;
}

.tabActive {
  position: relative;

  &:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    background-color: #46b8b0;
    left: 0;
    bottom: 0;
  }
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/materialSearch/materialSearch.vue